var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.958,
    height: 63.521,
    viewBox: "0 0 62.958 63.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(-123.041 -537.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(-900.501 38.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M1086.5,530.7a31.48,31.48,0,1,1-31.479-31.76A31.62,31.62,0,0,1,1086.5,530.7",
    transform: "translate(0 0)",
    fill: "#add095"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(-6519.639 -2415.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M6674.629,2967.222c2.8,0,5.6-.007,8.4,0a9.43,9.43,0,0,1,1.964,18.652,15.113,15.113,0,0,1-3.241.2c-1.1,0-2.209.017-3.314-.008a1.229,1.229,0,0,0-.985.406c-1.564,1.588-3.15,3.155-4.72,4.737a1.13,1.13,0,0,1-1.382.341,1.062,1.062,0,0,1-.57-1.083c.007-1.223-.025-2.447.014-3.669.017-.553-.115-.759-.71-.738-1.32.046-2.643.024-3.964.011a9.423,9.423,0,0,1,.041-18.845C6668.987,2967.212,6671.808,2967.222,6674.629,2967.222Zm-4.751,13.254a.971.971,0,0,0,.8-.616,1,1,0,0,0-.207-1.152c-.577-.595-1.156-1.187-1.755-1.758-.244-.232-.246-.381,0-.613.558-.528,1.1-1.078,1.633-1.629a1.074,1.074,0,0,0,.138-1.576,1.063,1.063,0,0,0-1.617.091c-.523.508-1.054,1.011-1.542,1.552-.308.342-.51.3-.8-.013-.479-.523-.994-1.014-1.5-1.51-.561-.547-1.166-.6-1.62-.153a1.106,1.106,0,0,0,.125,1.624c.536.551,1.079,1.1,1.631,1.631.219.212.221.368,0,.581-.527.5-1.037,1.026-1.55,1.545-.594.6-.667,1.248-.2,1.707s1.079.377,1.7-.24c.49-.486.99-.963,1.46-1.468.258-.278.439-.3.711-.01.509.549,1.056,1.063,1.584,1.595A1.233,1.233,0,0,0,6669.878,2980.476Zm16.963-6.417a1.366,1.366,0,0,0-.032-.226,1.046,1.046,0,0,0-1.831-.357q-1.9,1.9-3.773,3.834c-.279.289-.456.332-.748.017-.562-.606-1.158-1.183-1.752-1.758a1.062,1.062,0,0,0-1.575-.1,1.074,1.074,0,0,0,.1,1.575q1.368,1.39,2.758,2.759a1.05,1.05,0,0,0,1.7-.005c1.6-1.608,3.182-3.227,4.773-4.841A1.18,1.18,0,0,0,6686.841,2974.059Z",
    transform: "translate(-0.106 0)",
    fill: "#fefdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M6663.328,3219.561c-1.8,0-3.592,0-5.388,0-.87,0-1.23-.352-1.25-1.209a6.908,6.908,0,0,1,.619-3.688,5.846,5.846,0,0,1,1.352-1.631c.22-.186.374-.176.6.018a5.84,5.84,0,0,0,8.144-.009c.281-.234.435-.143.646.037a5.256,5.256,0,0,1,1.918,3.861c.028.492.026.987.007,1.479a1.052,1.052,0,0,1-1.2,1.141C6666.959,3219.565,6665.144,3219.561,6663.328,3219.561Z",
    transform: "translate(0 -216.574)",
    fill: "#fefdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M6684.191,3153a3.845,3.845,0,1,1,3.861-3.819A3.854,3.854,0,0,1,6684.191,3153Z",
    transform: "translate(-20.879 -156.99)",
    fill: "#fefdfd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.0e4daa1dc75ca020fc0eb2670fe5a0a5.svg";
export { ForwardRef as ReactComponent };